/* Control de EPP: pantalla principal para admins (SSHO) y responsables de depósito.
 * Indicadores de las entregas vigentes de sus depósitos y accesos a cada función. */
import { IonContent, IonIcon, IonPage } from "@ionic/react";
import {
  cubeOutline,
  handRightOutline,
  listOutline,
  settingsOutline,
} from "ionicons/icons";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "src/components/Header";
import { Cargando, useRolEpp, useToastEpp } from "src/components/epp/EppComunes";
import EppAPI, { EstadoEpp, ResumenEpp, plural } from "src/services/epp";
import "./Epp.css";

const INDICADORES: { estado: EstadoEpp; label: string }[] = [
  { estado: "PLAZO_CUMPLIDO", label: "Plazo cumplido" },
  { estado: "PROXIMO_A_VENCER", label: "Próximos a vencer" },
  { estado: "RETIRO_ANTICIPADO", label: "Retiro anticipado" },
  { estado: "DENTRO_DEL_PLAZO", label: "Dentro del plazo" },
  { estado: "DEFINIR_DURACION", label: "Definir duración" },
];

const EppInicio: React.FC = () => {
  const history = useHistory();
  const rol = useRolEpp();
  const toast = useToastEpp();
  const [resumen, setResumen] = useState<ResumenEpp | null>(null);

  useEffect(() => {
    EppAPI.resumen()
      .then(setResumen)
      .catch((err) => toast.error(err, "No se pudo cargar el resumen"));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const accesos = [
    { titulo: "Registrar entrega", icono: handRightOutline, url: "/epp/entrega", ver: true },
    { titulo: "Stock", icono: cubeOutline, url: "/epp/stock", ver: true },
    { titulo: "Registro de entregas", icono: listOutline, url: "/epp/registro", ver: true },
    { titulo: "Catálogo y depósitos", icono: settingsOutline, url: "/epp/admin", ver: Boolean(rol?.admin) },
  ];

  return (
    <IonPage>
      <Header titulo="Control de EPP" />
      <IonContent id="epp-inicio">
        <div className="epp-page">
          <p className="epp-card-titulo">EPP vigentes de tus depósitos</p>
          {!resumen ? (
            <Cargando />
          ) : (
            <div className="epp-stats">
              {INDICADORES.map((i) => (
                <div
                  key={i.estado}
                  className="epp-stat"
                  onClick={() => history.push(`/epp/registro?estado=${i.estado}&vigentes=1`)}
                >
                  <div className="epp-stat-valor">{resumen.por_estado[i.estado] || 0}</div>
                  <div className="epp-stat-label">{i.label}</div>
                </div>
              ))}
            </div>
          )}
          {Boolean(resumen?.anticipadas) && (
            <div className="epp-aviso alerta" style={{ cursor: "pointer" }} onClick={() => history.push("/epp/registro?anticipadas=1")}>
              {plural(resumen!.anticipadas, "retiro anticipado", "retiros anticipados")} en los últimos{" "}
              {resumen!.dias_anticipadas} días. Ver detalle.
            </div>
          )}
          {rol && !rol.depositos.length && (
            <div className="epp-aviso">Todavía no hay depósitos activos. Creá uno en "Catálogo y depósitos".</div>
          )}
          <div className="epp-accesos">
            {accesos
              .filter((a) => a.ver)
              .map((a) => (
                <div key={a.url} className="epp-acceso" onClick={() => history.push(a.url)}>
                  <IonIcon icon={a.icono} />
                  {a.titulo}
                </div>
              ))}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default EppInicio;
